export default __webpack_public_path__ + "static/media/infiniti.8270248e.svg";